export function toggleArrayValue<T>(value: T, array: T[]) {
  return array.includes(value) ? array.filter((v) => v !== value) : [...array, value];
}
